var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowPasswordBlur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0227 15.8337C14.4498 15.8337 18.3332 11.9448 18.3332 10.0003C18.3332 8.05588 14.9706 4.16699 10.0227 4.16699C5.33523 4.16699 1.6665 8.05588 1.6665 10.0003C1.6665 11.9448 5.59564 15.8337 10.0227 15.8337ZM9.99989 13.5003C11.9723 13.5003 13.5713 11.9333 13.5713 10.0003C13.5713 8.06733 11.9723 6.50033 9.99989 6.50033C8.02743 6.50033 6.42844 8.06733 6.42844 10.0003C6.42844 11.9333 8.02743 13.5003 9.99989 13.5003Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.984 10.0003C11.984 11.0742 11.0957 11.9448 9.99989 11.9448C8.90408 11.9448 8.01575 11.0742 8.01575 10.0003C8.01575 8.92644 8.90408 8.05588 9.99989 8.05588C11.0957 8.05588 11.984 8.92644 11.984 10.0003Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPasswordBlur);
export default __webpack_public_path__ + "static/media/show-password-blur.60d47a8b9a800fcf704ef7de1274ab7b.svg";
export { ForwardRef as ReactComponent };